var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScoreChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 278,
    viewBox: "0 0 276 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_7996)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.650391,
    width: 275.637,
    height: 276.699,
    rx: 9.58737,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    y: 138.867,
    width: 137.419,
    height: 138.218,
    fill: "#C5F2DC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 138.219,
    y: 138.867,
    width: 137.419,
    height: 138.218,
    fill: "#FFE8BA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    y: 0.650391,
    width: 137.419,
    height: 138.218,
    fill: "#C5F2DC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 138.219,
    y: 0.650391,
    width: 137.419,
    height: 138.218,
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.091 139.087C197.091 106.572 170.732 80.2129 138.217 80.2129",
    stroke: "url(#paint0_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.738 139.088C191.738 109.529 167.776 85.5664 138.217 85.5664",
    stroke: "url(#paint1_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.443 139.091C202.443 103.62 173.688 74.8652 138.217 74.8652",
    stroke: "url(#paint2_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.795 139.09C207.795 100.663 176.644 69.5117 138.217 69.5117",
    stroke: "url(#paint3_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.147 139.086C213.147 97.7036 179.6 64.1562 138.217 64.1562",
    stroke: "url(#paint4_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.499 139.087C218.499 94.7483 182.556 58.8047 138.217 58.8047",
    stroke: "url(#paint5_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.851 139.086C223.851 91.791 185.511 53.4512 138.217 53.4512",
    stroke: "url(#paint6_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.203 138.768C229.203 88.5174 188.467 47.7812 138.217 47.7812",
    stroke: "url(#paint7_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.556 139.089C234.556 85.8823 191.423 42.75 138.217 42.75",
    stroke: "url(#paint8_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.908 139.087C239.908 82.9251 194.379 37.3965 138.217 37.3965",
    stroke: "url(#paint9_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7454 139.087C77.7454 106.572 104.104 80.2129 136.619 80.2129",
    stroke: "url(#paint10_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0976 139.088C83.0976 109.529 107.06 85.5664 136.619 85.5664",
    stroke: "url(#paint11_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3933 139.089C72.3933 103.618 101.148 74.8633 136.619 74.8633",
    stroke: "url(#paint12_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0411 139.09C67.0411 100.663 98.1923 69.5117 136.619 69.5117",
    stroke: "url(#paint13_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.689 139.088C61.689 97.7056 95.2364 64.1582 136.619 64.1582",
    stroke: "url(#paint14_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3368 139.085C56.3368 94.7464 92.2804 58.8027 136.619 58.8027",
    stroke: "url(#paint15_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9847 139.086C50.9847 91.791 89.3245 53.4512 136.619 53.4512",
    stroke: "url(#paint16_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6325 139.088C45.6325 88.8377 86.3686 48.1016 136.619 48.1016",
    stroke: "url(#paint17_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2804 139.087C40.2804 85.8804 83.4127 42.748 136.619 42.748",
    stroke: "url(#paint18_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9282 139.087C34.9282 82.9251 80.4568 37.3965 136.619 37.3965",
    stroke: "url(#paint19_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.576 139.086C29.576 79.9678 77.5009 32.043 136.619 32.043",
    stroke: "url(#paint20_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.091 140.107C197.091 172.622 170.732 198.98 138.217 198.98",
    stroke: "url(#paint21_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.738 140.103C191.738 169.663 167.776 193.625 138.217 193.625",
    stroke: "url(#paint22_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.443 140.106C202.443 175.577 173.688 204.332 138.217 204.332",
    stroke: "url(#paint23_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.795 140.104C207.795 178.531 176.644 209.682 138.217 209.682",
    stroke: "url(#paint24_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.147 140.105C213.147 181.488 179.6 215.035 138.217 215.035",
    stroke: "url(#paint25_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.499 140.104C218.499 184.443 182.556 220.387 138.217 220.387",
    stroke: "url(#paint26_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.851 140.106C223.851 187.4 185.511 225.74 138.217 225.74",
    stroke: "url(#paint27_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7454 140.107C77.7454 172.622 104.104 198.98 136.619 198.98",
    stroke: "url(#paint28_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0976 140.105C83.0976 169.665 107.06 193.627 136.619 193.627",
    stroke: "url(#paint29_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3933 140.106C72.3933 175.577 101.148 204.332 136.619 204.332",
    stroke: "url(#paint30_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0411 140.104C67.0411 178.531 98.1923 209.682 136.619 209.682",
    stroke: "url(#paint31_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.689 140.107C61.689 181.49 95.2364 215.037 136.619 215.037",
    stroke: "url(#paint32_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3368 140.106C56.3368 184.445 92.2804 220.389 136.619 220.389",
    stroke: "url(#paint33_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9847 140.108C50.9847 187.402 89.3245 225.742 136.619 225.742",
    stroke: "url(#paint34_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6325 140.109C45.6325 190.36 86.3686 231.096 136.619 231.096",
    stroke: "url(#paint35_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2804 140.105C40.2804 193.311 83.4127 236.443 136.619 236.443",
    stroke: "url(#paint36_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9282 140.106C34.9282 196.268 80.4568 241.797 136.619 241.797",
    stroke: "url(#paint37_linear_116_7996)",
    strokeWidth: 3.63732,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.763,
    y1: 276.684,
    x2: 137.763,
    y2: 1.04657,
    stroke: "white",
    strokeWidth: 2.72799
  }), /*#__PURE__*/React.createElement("line", {
    y1: 140.005,
    x2: 275.637,
    y2: 140.005,
    stroke: "white",
    strokeWidth: 2.72799
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_116_7996)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 137.418,
    cy: 139.666,
    r: 52.7306,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.701 164.883C117.264 164.883 116.337 163.765 116.337 162.455C116.337 161.146 117.264 160.027 118.701 160.027C120.138 160.027 121.065 161.146 121.065 162.455C121.065 163.765 120.138 164.883 118.701 164.883ZM118.701 164.174C119.647 164.174 120.265 163.456 120.265 162.455C120.265 161.455 119.647 160.737 118.701 160.737C117.755 160.737 117.137 161.455 117.137 162.455C117.137 163.456 117.755 164.174 118.701 164.174ZM124.265 164.883C123.065 164.883 122.283 164.147 122.283 163.037V160.155H123.047V162.992C123.047 163.765 123.493 164.174 124.265 164.174C125.038 164.174 125.484 163.765 125.484 162.992V160.155H126.248V163.037C126.248 164.147 125.466 164.883 124.265 164.883ZM129.528 164.829C128.628 164.829 128.127 164.401 128.127 163.574V160.809H127.209V160.155H128.127V158.791H128.891V160.155H130.337V160.809H128.891V163.519C128.891 163.974 129.119 164.156 129.637 164.156C129.837 164.156 130.092 164.128 130.355 164.074V164.71C130.055 164.801 129.755 164.829 129.528 164.829ZM135.653 164.883C134.216 164.883 133.289 163.765 133.289 162.455C133.289 161.146 134.216 160.027 135.653 160.027C137.09 160.027 138.017 161.146 138.017 162.455C138.017 163.765 137.09 164.883 135.653 164.883ZM135.653 164.174C136.599 164.174 137.217 163.456 137.217 162.455C137.217 161.455 136.599 160.737 135.653 160.737C134.708 160.737 134.089 161.455 134.089 162.455C134.089 163.456 134.708 164.174 135.653 164.174ZM139.601 164.756V160.809H138.656V160.155H139.601V159.454C139.601 158.454 140.074 158.018 141.029 158.018C141.22 158.018 141.456 158.036 141.729 158.1V158.745C141.493 158.7 141.283 158.682 141.129 158.682C140.601 158.682 140.365 158.909 140.365 159.473V160.155H141.711V160.809H140.365V164.756H139.601ZM146.181 158.391H146.826V164.756H146.044V159.236L144.353 160.1V159.327L146.181 158.391ZM151.015 164.883C149.451 164.883 148.46 163.665 148.46 161.573C148.46 159.482 149.451 158.263 151.015 158.263C152.579 158.263 153.57 159.482 153.57 161.573C153.57 163.665 152.579 164.883 151.015 164.883ZM151.015 164.156C152.124 164.156 152.752 163.319 152.752 161.573C152.752 159.827 152.124 158.991 151.015 158.991C149.906 158.991 149.278 159.827 149.278 161.573C149.278 163.319 149.906 164.156 151.015 164.156ZM157.4 164.883C155.836 164.883 154.845 163.665 154.845 161.573C154.845 159.482 155.836 158.263 157.4 158.263C158.964 158.263 159.955 159.482 159.955 161.573C159.955 163.665 158.964 164.883 157.4 164.883ZM157.4 164.156C158.509 164.156 159.137 163.319 159.137 161.573C159.137 159.827 158.509 158.991 157.4 158.991C156.29 158.991 155.663 159.827 155.663 161.573C155.663 163.319 156.29 164.156 157.4 164.156Z",
    fill: "#576F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.125 137.274C135.486 138.474 137.287 140.835 137.287 144.076C137.287 148.797 133.406 152.238 126.404 152.238C119.362 152.238 115.481 148.797 115.481 144.076C115.481 140.835 117.282 138.474 120.682 137.274C117.802 136.074 116.281 133.833 116.281 130.992C116.281 126.631 119.842 123.11 126.404 123.11C132.926 123.11 136.487 126.631 136.487 130.992C136.487 133.833 134.966 136.074 132.125 137.274ZM126.404 127.872C123.403 127.872 121.963 129.312 121.963 131.512C121.963 133.753 123.403 135.153 126.404 135.153C129.365 135.153 130.805 133.753 130.805 131.512C130.805 129.312 129.365 127.872 126.404 127.872ZM126.404 147.277C129.765 147.277 131.325 145.716 131.325 143.516C131.325 141.275 129.765 139.715 126.404 139.715C122.963 139.715 121.443 141.275 121.443 143.516C121.443 145.716 122.963 147.277 126.404 147.277ZM151.172 133.753C156.694 133.753 160.415 137.074 160.415 142.675C160.415 148.717 156.134 152.238 149.452 152.238C145.451 152.238 142.13 150.958 139.289 148.077L142.57 144.116C144.771 146.196 147.011 146.997 149.332 146.997C152.613 146.997 154.573 145.396 154.573 142.795C154.573 140.235 152.733 138.634 149.852 138.634C148.091 138.634 146.491 139.234 145.171 140.195L140.89 138.034V123.67H158.654V128.832H146.291V134.873C147.691 134.113 149.292 133.753 151.172 133.753Z",
    fill: "#004061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.25 266.443V258.805H193.635V266.443H192.25ZM198.673 260.736C199.873 260.736 200.604 261.489 200.604 262.842V266.443H199.273V263.181C199.273 262.34 198.946 261.959 198.215 261.959C197.407 261.959 196.873 262.428 196.873 263.257V266.443H195.541V260.889H196.851V261.74C197.156 261.118 197.822 260.736 198.673 260.736ZM202.748 266.443V262.057H201.679V260.889H202.748V260.169C202.748 258.99 203.338 258.358 204.68 258.358C204.953 258.358 205.258 258.379 205.585 258.456V259.58C205.334 259.536 205.127 259.514 204.931 259.514C204.331 259.514 204.08 259.743 204.08 260.278V260.889H205.575V262.057H204.08V266.443H202.748ZM206.725 266.443V258.456H208.056V266.443H206.725ZM213.921 260.889H215.23V266.443H213.921V265.559C213.593 266.214 212.862 266.596 212.022 266.596C210.549 266.596 209.468 265.407 209.468 263.672C209.468 261.937 210.549 260.736 212.022 260.736C212.862 260.736 213.593 261.129 213.921 261.784V260.889ZM212.393 265.385C213.353 265.385 213.953 264.676 213.953 263.672C213.953 262.657 213.353 261.948 212.393 261.948C211.433 261.948 210.832 262.657 210.832 263.672C210.832 264.676 211.433 265.385 212.393 265.385ZM223.637 260.736C224.815 260.736 225.503 261.5 225.503 262.832V266.443H224.172V263.159C224.172 262.34 223.877 261.959 223.2 261.959C222.437 261.959 221.913 262.428 221.913 263.246V266.443H220.582V263.159C220.582 262.34 220.287 261.959 219.61 261.959C218.847 261.959 218.334 262.428 218.334 263.246V266.443H217.002V260.889H218.312V261.729C218.617 261.118 219.272 260.736 220.069 260.736C220.876 260.736 221.476 261.129 221.738 261.817C222.033 261.162 222.742 260.736 223.637 260.736ZM233.859 260.736C235.037 260.736 235.725 261.5 235.725 262.832V266.443H234.393V263.159C234.393 262.34 234.099 261.959 233.422 261.959C232.658 261.959 232.135 262.428 232.135 263.246V266.443H230.803V263.159C230.803 262.34 230.509 261.959 229.832 261.959C229.068 261.959 228.556 262.428 228.556 263.246V266.443H227.224V260.889H228.534V261.729C228.839 261.118 229.494 260.736 230.291 260.736C231.098 260.736 231.698 261.129 231.96 261.817C232.255 261.162 232.964 260.736 233.859 260.736ZM241.549 260.889H242.859V266.443H241.549V265.559C241.222 266.214 240.491 266.596 239.65 266.596C238.177 266.596 237.097 265.407 237.097 263.672C237.097 261.937 238.177 260.736 239.65 260.736C240.491 260.736 241.222 261.129 241.549 261.784V260.889ZM240.021 265.385C240.982 265.385 241.582 264.676 241.582 263.672C241.582 262.657 240.982 261.948 240.021 261.948C239.061 261.948 238.461 262.657 238.461 263.672C238.461 264.676 239.061 265.385 240.021 265.385ZM246.933 266.531C245.679 266.531 245.089 265.996 245.089 264.817V262.057H244.042V260.889H245.089V259.252H246.421V260.889H247.992V262.057H246.421V264.643C246.421 265.156 246.65 265.341 247.217 265.341C247.446 265.341 247.73 265.319 248.014 265.254V266.378C247.654 266.487 247.294 266.531 246.933 266.531ZM250.02 259.962C249.507 259.962 249.169 259.612 249.169 259.132C249.169 258.652 249.507 258.303 250.02 258.303C250.522 258.303 250.86 258.652 250.86 259.132C250.86 259.612 250.522 259.962 250.02 259.962ZM249.355 266.443V260.889H250.686V266.443H249.355ZM255.033 266.596C253.254 266.596 252.109 265.276 252.109 263.672C252.109 262.057 253.254 260.736 255.033 260.736C256.823 260.736 257.957 262.057 257.957 263.672C257.957 265.276 256.823 266.596 255.033 266.596ZM255.033 265.385C255.993 265.385 256.593 264.676 256.593 263.672C256.593 262.657 255.993 261.948 255.033 261.948C254.073 261.948 253.473 262.657 253.473 263.672C253.473 264.676 254.073 265.385 255.033 265.385ZM262.508 260.736C263.708 260.736 264.439 261.489 264.439 262.842V266.443H263.108V263.181C263.108 262.34 262.781 261.959 262.05 261.959C261.242 261.959 260.707 262.428 260.707 263.257V266.443H259.376V260.889H260.686V261.74C260.991 261.118 261.657 260.736 262.508 260.736Z",
    fill: "#004061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.752 242.256H18.3342V249.895H16.9811V244.286L14.7333 248.007H13.653L11.4051 244.286V249.895H10.052V242.256H11.6452L14.1986 246.501L16.752 242.256ZM25.2913 247.003C25.2913 247.167 25.2804 247.341 25.2586 247.516H21.123C21.2648 248.411 21.8541 248.891 22.7598 248.891C23.3818 248.891 23.9055 248.661 24.3093 248.192L25.1058 248.978C24.5821 249.654 23.7419 250.047 22.7161 250.047C20.9484 250.047 19.7699 248.891 19.7699 247.145C19.7699 245.421 20.9047 244.188 22.5852 244.188C24.2002 244.188 25.2913 245.312 25.2913 247.003ZM22.5961 245.344C21.7777 245.344 21.2648 245.813 21.123 246.61H23.9601C23.8946 245.792 23.3927 245.344 22.5961 245.344ZM28.7833 249.982C27.5284 249.982 26.9391 249.447 26.9391 248.269V245.508H25.8916V244.34H26.9391V242.704H28.2704V244.34H29.8417V245.508H28.2704V248.094C28.2704 248.607 28.4995 248.792 29.067 248.792C29.2961 248.792 29.5798 248.771 29.8635 248.705V249.829C29.5034 249.938 29.1434 249.982 28.7833 249.982ZM35.0913 244.34H36.4007V249.895H35.0913V249.011C34.7639 249.665 34.0328 250.047 33.1926 250.047C31.7195 250.047 30.6392 248.858 30.6392 247.123C30.6392 245.388 31.7195 244.188 33.1926 244.188C34.0328 244.188 34.7639 244.58 35.0913 245.235V244.34ZM33.5636 248.836C34.5239 248.836 35.124 248.127 35.124 247.123C35.124 246.108 34.5239 245.399 33.5636 245.399C32.6034 245.399 32.0032 246.108 32.0032 247.123C32.0032 248.127 32.6034 248.836 33.5636 248.836ZM41.2722 244.188C42.7563 244.188 43.8256 245.388 43.8256 247.123C43.8256 248.858 42.7563 250.047 41.2722 250.047C40.432 250.047 39.7009 249.665 39.3736 249.011V249.895H38.0641V241.907H39.3954V245.191C39.7336 244.559 40.4538 244.188 41.2722 244.188ZM40.9012 248.836C41.8506 248.836 42.4616 248.127 42.4616 247.123C42.4616 246.108 41.8506 245.399 40.9012 245.399C39.941 245.399 39.3408 246.108 39.3408 247.123C39.3408 248.127 39.941 248.836 40.9012 248.836ZM47.7151 250.047C45.9364 250.047 44.7907 248.727 44.7907 247.123C44.7907 245.508 45.9364 244.188 47.7151 244.188C49.5046 244.188 50.6395 245.508 50.6395 247.123C50.6395 248.727 49.5046 250.047 47.7151 250.047ZM47.7151 248.836C48.6753 248.836 49.2755 248.127 49.2755 247.123C49.2755 246.108 48.6753 245.399 47.7151 245.399C46.7548 245.399 46.1547 246.108 46.1547 247.123C46.1547 248.127 46.7548 248.836 47.7151 248.836ZM51.9491 249.895V241.907H53.2804V249.895H51.9491ZM55.6094 243.413C55.0966 243.413 54.7583 243.064 54.7583 242.584C54.7583 242.103 55.0966 241.754 55.6094 241.754C56.1114 241.754 56.4496 242.103 56.4496 242.584C56.4496 243.064 56.1114 243.413 55.6094 243.413ZM54.9438 249.895V244.34H56.2751V249.895H54.9438ZM60.4804 250.047C58.7454 250.047 57.5887 248.836 57.5887 247.123C57.5887 245.399 58.7454 244.188 60.4804 244.188C61.5498 244.188 62.4227 244.657 62.881 245.442L61.8771 246.152C61.5607 245.65 61.0806 245.41 60.5132 245.41C59.5747 245.41 58.9527 246.075 58.9527 247.123C58.9527 248.16 59.5747 248.836 60.5132 248.836C61.0806 248.836 61.5607 248.585 61.8771 248.083L62.881 248.792C62.4227 249.589 61.5498 250.047 60.4804 250.047ZM15.1588 256.256H16.5447V263.895H15.1588V260.632H11.4379V263.895H10.052V256.256H11.4379V259.344H15.1588V256.256ZM23.4905 261.003C23.4905 261.167 23.4795 261.341 23.4577 261.516H19.3221C19.4639 262.411 20.0532 262.891 20.9589 262.891C21.5809 262.891 22.1046 262.661 22.5084 262.192L23.3049 262.978C22.7812 263.654 21.941 264.047 20.9152 264.047C19.1475 264.047 17.969 262.891 17.969 261.145C17.969 259.421 19.1038 258.188 20.7843 258.188C22.3993 258.188 23.4905 259.312 23.4905 261.003ZM20.7952 259.344C19.9768 259.344 19.4639 259.813 19.3221 260.61H22.1592C22.0937 259.792 21.5918 259.344 20.7952 259.344ZM28.8787 258.34H30.1882V263.895H28.8787V263.011C28.5514 263.665 27.8203 264.047 26.9801 264.047C25.5069 264.047 24.4267 262.858 24.4267 261.123C24.4267 259.388 25.5069 258.188 26.9801 258.188C27.8203 258.188 28.5514 258.58 28.8787 259.235V258.34ZM27.3511 262.836C28.3113 262.836 28.9115 262.127 28.9115 261.123C28.9115 260.108 28.3113 259.399 27.3511 259.399C26.3908 259.399 25.7907 260.108 25.7907 261.123C25.7907 262.127 26.3908 262.836 27.3511 262.836ZM31.8516 263.895V255.907H33.1828V263.895H31.8516ZM37.1377 263.982C35.8828 263.982 35.2936 263.447 35.2936 262.269V259.508H34.2461V258.34H35.2936V256.704H36.6249V258.34H38.1962V259.508H36.6249V262.094C36.6249 262.607 36.854 262.792 37.4214 262.792C37.6506 262.792 37.9343 262.771 38.218 262.705V263.829C37.8579 263.938 37.4978 263.982 37.1377 263.982ZM42.5705 258.188C43.7708 258.188 44.5019 258.941 44.5019 260.294V263.895H43.1707V260.632C43.1707 259.792 42.8433 259.41 42.1122 259.41C41.3047 259.41 40.77 259.879 40.77 260.708V263.895H39.4388V255.907H40.77V259.148C41.0865 258.548 41.7412 258.188 42.5705 258.188Z",
    fill: "#004061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1588 13.1038H16.5447V20.7422H15.1588V17.4795H11.4379V20.7422H10.052V13.1038H11.4379V16.1919H15.1588V13.1038ZM23.4905 17.8505C23.4905 18.0142 23.4795 18.1888 23.4577 18.3634H19.3221C19.4639 19.2582 20.0532 19.7383 20.9589 19.7383C21.5809 19.7383 22.1046 19.5091 22.5084 19.0399L23.3049 19.8256C22.7812 20.5021 21.941 20.895 20.9152 20.895C19.1475 20.895 17.969 19.7383 17.969 17.9924C17.969 16.2683 19.1038 15.0352 20.7843 15.0352C22.3993 15.0352 23.4905 16.1592 23.4905 17.8505ZM20.7952 16.1919C19.9768 16.1919 19.4639 16.6611 19.3221 17.4577H22.1592C22.0937 16.6393 21.5918 16.1919 20.7952 16.1919ZM28.8787 15.188H30.1882V20.7422H28.8787V19.8583C28.5514 20.513 27.8203 20.895 26.9801 20.895C25.5069 20.895 24.4267 19.7056 24.4267 17.9706C24.4267 16.2356 25.5069 15.0352 26.9801 15.0352C27.8203 15.0352 28.5514 15.4281 28.8787 16.0828V15.188ZM27.3511 19.6837C28.3113 19.6837 28.9115 18.9745 28.9115 17.9706C28.9115 16.9557 28.3113 16.2465 27.3511 16.2465C26.3908 16.2465 25.7907 16.9557 25.7907 17.9706C25.7907 18.9745 26.3908 19.6837 27.3511 19.6837ZM34.7978 15.0898C34.9724 15.0898 35.1251 15.1116 35.2779 15.1662V16.4101C35.0706 16.3774 34.8523 16.3556 34.6668 16.3556C33.6957 16.3556 33.1828 16.8466 33.1828 18.0033V20.7422H31.8516V15.188H33.161V16.1155C33.4338 15.4717 34.0339 15.0898 34.7978 15.0898ZM38.8427 20.8295C37.5878 20.8295 36.9986 20.2948 36.9986 19.1163V16.3556H35.951V15.188H36.9986V13.5512H38.3298V15.188H39.9012V16.3556H38.3298V18.9417C38.3298 19.4546 38.559 19.6401 39.1264 19.6401C39.3556 19.6401 39.6393 19.6183 39.923 19.5528V20.6767C39.5629 20.7858 39.2028 20.8295 38.8427 20.8295ZM15.1588 27.1038H16.5447V34.7422H15.1588V31.4795H11.4379V34.7422H10.052V27.1038H11.4379V30.1919H15.1588V27.1038ZM23.4905 31.8505C23.4905 32.0142 23.4795 32.1888 23.4577 32.3634H19.3221C19.4639 33.2582 20.0532 33.7383 20.9589 33.7383C21.5809 33.7383 22.1046 33.5091 22.5084 33.0399L23.3049 33.8256C22.7812 34.5021 21.941 34.895 20.9152 34.895C19.1475 34.895 17.969 33.7383 17.969 31.9924C17.969 30.2683 19.1038 29.0352 20.7843 29.0352C22.3993 29.0352 23.4905 30.1592 23.4905 31.8505ZM20.7952 30.1919C19.9768 30.1919 19.4639 30.6611 19.3221 31.4577H22.1592C22.0937 30.6393 21.5918 30.1919 20.7952 30.1919ZM28.8787 29.188H30.1882V34.7422H28.8787V33.8583C28.5514 34.513 27.8203 34.895 26.9801 34.895C25.5069 34.895 24.4267 33.7056 24.4267 31.9706C24.4267 30.2356 25.5069 29.0352 26.9801 29.0352C27.8203 29.0352 28.5514 29.4281 28.8787 30.0828V29.188ZM27.3511 33.6837C28.3113 33.6837 28.9115 32.9745 28.9115 31.9706C28.9115 30.9557 28.3113 30.2465 27.3511 30.2465C26.3908 30.2465 25.7907 30.9557 25.7907 31.9706C25.7907 32.9745 26.3908 33.6837 27.3511 33.6837ZM31.8516 34.7422V26.7546H33.1828V34.7422H31.8516ZM37.1377 34.8295C35.8828 34.8295 35.2936 34.2948 35.2936 33.1163V30.3556H34.2461V29.188H35.2936V27.5512H36.6249V29.188H38.1962V30.3556H36.6249V32.9417C36.6249 33.4546 36.854 33.6401 37.4214 33.6401C37.6506 33.6401 37.9343 33.6183 38.218 33.5528V34.6767C37.8579 34.7858 37.4978 34.8295 37.1377 34.8295ZM42.5705 29.0352C43.7708 29.0352 44.5019 29.7882 44.5019 31.1412V34.7422H43.1707V31.4795C43.1707 30.6393 42.8433 30.2574 42.1122 30.2574C41.3047 30.2574 40.77 30.7266 40.77 31.5559V34.7422H39.4388V26.7546H40.77V29.9955C41.0865 29.3953 41.7412 29.0352 42.5705 29.0352Z",
    fill: "#004061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.187 20.895C206.862 20.895 205.269 19.2036 205.269 16.923C205.269 14.6642 206.852 12.9511 209.187 12.9511C210.66 12.9511 211.936 13.6385 212.58 14.9916L211.391 15.6245C210.933 14.6861 210.158 14.2496 209.219 14.2496C207.724 14.2496 206.721 15.3735 206.721 16.923C206.721 18.4725 207.724 19.5964 209.219 19.5964C210.158 19.5964 210.943 19.16 211.402 18.2215L212.58 18.8544C211.936 20.2075 210.66 20.895 209.187 20.895ZM216.815 15.0352C218.015 15.0352 218.746 15.7882 218.746 17.1412V20.7422H217.415V17.4795C217.415 16.6393 217.088 16.2574 216.357 16.2574C215.549 16.2574 215.014 16.7266 215.014 17.5559V20.7422H213.683V12.7546H215.014V15.9955C215.331 15.3953 215.986 15.0352 216.815 15.0352ZM222.929 20.895C221.151 20.895 220.005 19.5746 220.005 17.9706C220.005 16.3556 221.151 15.0352 222.929 15.0352C224.719 15.0352 225.854 16.3556 225.854 17.9706C225.854 19.5746 224.719 20.895 222.929 20.895ZM222.929 19.6837C223.889 19.6837 224.49 18.9745 224.49 17.9706C224.49 16.9557 223.889 16.2465 222.929 16.2465C221.969 16.2465 221.369 16.9557 221.369 17.9706C221.369 18.9745 221.969 19.6837 222.929 19.6837ZM227.163 20.7422V12.7546H228.495V20.7422H227.163ZM235.319 17.8505C235.319 18.0142 235.308 18.1888 235.287 18.3634H231.151C231.293 19.2582 231.882 19.7383 232.788 19.7383C233.41 19.7383 233.933 19.5091 234.337 19.0399L235.134 19.8256C234.61 20.5021 233.77 20.895 232.744 20.895C230.976 20.895 229.798 19.7383 229.798 17.9924C229.798 16.2683 230.933 15.0352 232.613 15.0352C234.228 15.0352 235.319 16.1592 235.319 17.8505ZM232.624 16.1919C231.806 16.1919 231.293 16.6611 231.151 17.4577H233.988C233.923 16.6393 233.421 16.1919 232.624 16.1919ZM238.667 20.895C237.565 20.895 236.637 20.4803 236.135 19.8365L236.856 18.9963C237.292 19.4764 237.969 19.7601 238.678 19.7601C239.311 19.7601 239.66 19.52 239.66 19.1709C239.66 18.8762 239.442 18.6907 238.885 18.5598L237.98 18.3525C236.823 18.0797 236.332 17.545 236.332 16.7812C236.332 15.7554 237.183 15.0352 238.623 15.0352C239.605 15.0352 240.424 15.3735 240.904 15.9191L240.195 16.7812C239.715 16.3665 239.169 16.1701 238.591 16.1701C237.969 16.1701 237.663 16.3992 237.663 16.7375C237.663 16.9994 237.849 17.1631 238.438 17.294L239.398 17.5232C240.566 17.785 240.991 18.3197 240.991 19.0836C240.991 20.1857 240.14 20.895 238.667 20.895ZM244.512 20.8295C243.257 20.8295 242.668 20.2948 242.668 19.1163V16.3556H241.621V15.188H242.668V13.5512H243.999V15.188H245.571V16.3556H243.999V18.9417C243.999 19.4546 244.229 19.6401 244.796 19.6401C245.025 19.6401 245.309 19.6183 245.593 19.5528V20.6767C245.232 20.7858 244.872 20.8295 244.512 20.8295ZM251.89 17.8505C251.89 18.0142 251.879 18.1888 251.857 18.3634H247.721C247.863 19.2582 248.452 19.7383 249.358 19.7383C249.98 19.7383 250.504 19.5091 250.908 19.0399L251.704 19.8256C251.18 20.5021 250.34 20.895 249.314 20.895C247.547 20.895 246.368 19.7383 246.368 17.9924C246.368 16.2683 247.503 15.0352 249.183 15.0352C250.798 15.0352 251.89 16.1592 251.89 17.8505ZM249.194 16.1919C248.376 16.1919 247.863 16.6611 247.721 17.4577H250.558C250.493 16.6393 249.991 16.1919 249.194 16.1919ZM256.121 15.0898C256.296 15.0898 256.449 15.1116 256.601 15.1662V16.4101C256.394 16.3774 256.176 16.3556 255.99 16.3556C255.019 16.3556 254.506 16.8466 254.506 18.0033V20.7422H253.175V15.188H254.484V16.1155C254.757 15.4717 255.357 15.0898 256.121 15.0898ZM260.045 20.895C258.266 20.895 257.12 19.5746 257.12 17.9706C257.12 16.3556 258.266 15.0352 260.045 15.0352C261.834 15.0352 262.969 16.3556 262.969 17.9706C262.969 19.5746 261.834 20.895 260.045 20.895ZM260.045 19.6837C261.005 19.6837 261.605 18.9745 261.605 17.9706C261.605 16.9557 261.005 16.2465 260.045 16.2465C259.084 16.2465 258.484 16.9557 258.484 17.9706C258.484 18.9745 259.084 19.6837 260.045 19.6837ZM264.279 20.7422V12.7546H265.61V20.7422H264.279ZM227.986 30.8139C229 31.0321 229.59 31.6868 229.59 32.6798C229.59 33.9347 228.673 34.7422 227.167 34.7422H223.49V27.1038H226.905C228.389 27.1038 229.306 27.9004 229.306 29.0898C229.306 29.9628 228.826 30.5629 227.986 30.8139ZM226.6 28.3041H224.865V30.2574H226.6C227.506 30.2574 227.887 29.9082 227.887 29.2753C227.887 28.6424 227.506 28.3041 226.6 28.3041ZM226.862 33.5419C227.757 33.5419 228.149 33.1709 228.149 32.4943C228.149 31.8178 227.757 31.4468 226.862 31.4468H224.865V33.5419H226.862ZM235.102 29.188H236.412V34.7422H235.102V33.8583C234.775 34.513 234.044 34.895 233.204 34.895C231.731 34.895 230.65 33.7056 230.65 31.9706C230.65 30.2356 231.731 29.0352 233.204 29.0352C234.044 29.0352 234.775 29.4281 235.102 30.0828V29.188ZM233.575 33.6837C234.535 33.6837 235.135 32.9745 235.135 31.9706C235.135 30.9557 234.535 30.2465 233.575 30.2465C232.614 30.2465 232.014 30.9557 232.014 31.9706C232.014 32.9745 232.614 33.6837 233.575 33.6837ZM238.075 34.7422V26.7546H239.406V34.7422H238.075ZM245.162 29.188H246.471V34.7422H245.162V33.8583C244.834 34.513 244.103 34.895 243.263 34.895C241.79 34.895 240.71 33.7056 240.71 31.9706C240.71 30.2356 241.79 29.0352 243.263 29.0352C244.103 29.0352 244.834 29.4281 245.162 30.0828V29.188ZM243.634 33.6837C244.594 33.6837 245.195 32.9745 245.195 31.9706C245.195 30.9557 244.594 30.2465 243.634 30.2465C242.674 30.2465 242.074 30.9557 242.074 31.9706C242.074 32.9745 242.674 33.6837 243.634 33.6837ZM251.266 29.0352C252.467 29.0352 253.198 29.7882 253.198 31.1412V34.7422H251.867V31.4795C251.867 30.6393 251.539 30.2574 250.808 30.2574C250.001 30.2574 249.466 30.7266 249.466 31.5559V34.7422H248.135V29.188H249.444V30.0391C249.75 29.4172 250.415 29.0352 251.266 29.0352ZM257.348 34.895C255.613 34.895 254.456 33.6837 254.456 31.9706C254.456 30.2465 255.613 29.0352 257.348 29.0352C258.417 29.0352 259.29 29.5045 259.749 30.2901L258.745 30.9994C258.428 30.4974 257.948 30.2574 257.381 30.2574C256.442 30.2574 255.82 30.923 255.82 31.9706C255.82 33.0072 256.442 33.6837 257.381 33.6837C257.948 33.6837 258.428 33.4328 258.745 32.9308L259.749 33.6401C259.29 34.4367 258.417 34.895 257.348 34.895ZM265.977 31.8505C265.977 32.0142 265.966 32.1888 265.944 32.3634H261.809C261.951 33.2582 262.54 33.7383 263.446 33.7383C264.068 33.7383 264.591 33.5091 264.995 33.0399L265.792 33.8256C265.268 34.5021 264.428 34.895 263.402 34.895C261.634 34.895 260.456 33.7383 260.456 31.9924C260.456 30.2683 261.591 29.0352 263.271 29.0352C264.886 29.0352 265.977 30.1592 265.977 31.8505ZM263.282 30.1919C262.463 30.1919 261.951 30.6611 261.809 31.4577H264.646C264.58 30.6393 264.078 30.1919 263.282 30.1919Z",
    fill: "#004061"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_116_7996",
    x: 62.317,
    y: 68.0196,
    width: 150.202,
    height: 150.202,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.45455
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.1853
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_116_7996"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_116_7996",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_116_7996",
    x1: 167.654,
    y1: 139.087,
    x2: 167.654,
    y2: 80.2129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F66A61",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F66A61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_116_7996",
    x1: 164.978,
    y1: 139.088,
    x2: 164.978,
    y2: 85.5664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F66A61",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F66A61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_116_7996",
    x1: 170.33,
    y1: 139.091,
    x2: 170.33,
    y2: 74.8652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F66A61",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F66A61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_116_7996",
    x1: 173.006,
    y1: 139.09,
    x2: 173.006,
    y2: 69.5117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F66A61",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F66A61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_116_7996",
    x1: 175.682,
    y1: 139.086,
    x2: 175.682,
    y2: 64.1562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F66A61",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F66A61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_116_7996",
    x1: 178.358,
    y1: 139.087,
    x2: 178.359,
    y2: 58.8047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F66A61",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F66A61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_116_7996",
    x1: 181.034,
    y1: 139.086,
    x2: 181.035,
    y2: 53.4512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F66A61",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F66A61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_116_7996",
    x1: 183.71,
    y1: 138.768,
    x2: 183.711,
    y2: 47.7812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F66A61",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F66A61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_116_7996",
    x1: 186.386,
    y1: 139.089,
    x2: 186.387,
    y2: 42.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F66A61",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F66A61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_116_7996",
    x1: 189.062,
    y1: 139.087,
    x2: 189.063,
    y2: 37.3965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F66A61",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F66A61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_116_7996",
    x1: 107.182,
    y1: 80.2129,
    x2: 107.182,
    y2: 139.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BDA7B",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BDA7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_116_7996",
    x1: 109.858,
    y1: 85.5664,
    x2: 109.858,
    y2: 139.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BDA7B",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BDA7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_116_7996",
    x1: 104.506,
    y1: 74.8633,
    x2: 104.506,
    y2: 139.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BDA7B",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BDA7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_116_7996",
    x1: 101.83,
    y1: 69.5117,
    x2: 101.83,
    y2: 139.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BDA7B",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BDA7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_116_7996",
    x1: 99.1541,
    y1: 64.1582,
    x2: 99.1541,
    y2: 139.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BDA7B",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BDA7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_116_7996",
    x1: 96.478,
    y1: 58.8027,
    x2: 96.478,
    y2: 139.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BDA7B",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BDA7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_116_7996",
    x1: 93.8019,
    y1: 53.4512,
    x2: 93.8019,
    y2: 139.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BDA7B",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BDA7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_116_7996",
    x1: 91.1258,
    y1: 48.1016,
    x2: 91.1258,
    y2: 139.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BDA7B",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BDA7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_116_7996",
    x1: 88.4497,
    y1: 42.748,
    x2: 88.4497,
    y2: 139.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BDA7B",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BDA7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_116_7996",
    x1: 85.7737,
    y1: 37.3965,
    x2: 85.7737,
    y2: 139.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BDA7B",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BDA7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_116_7996",
    x1: 83.0976,
    y1: 32.043,
    x2: 83.0976,
    y2: 139.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BDA7B",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BDA7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_116_7996",
    x1: 137.696,
    y1: 169.544,
    x2: 196.569,
    y2: 169.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00520833,
    stopColor: "#F9A542",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_116_7996",
    x1: 137.743,
    y1: 166.864,
    x2: 191.265,
    y2: 166.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00520833,
    stopColor: "#F9A542",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_116_7996",
    x1: 137.648,
    y1: 172.219,
    x2: 201.874,
    y2: 172.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00520833,
    stopColor: "#F9A542",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_116_7996",
    x1: 137.601,
    y1: 174.893,
    x2: 207.179,
    y2: 174.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00520833,
    stopColor: "#F9A542",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_116_7996",
    x1: 137.554,
    y1: 177.57,
    x2: 212.484,
    y2: 177.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00520833,
    stopColor: "#F9A542",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_116_7996",
    x1: 137.506,
    y1: 180.246,
    x2: 217.789,
    y2: 180.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00520833,
    stopColor: "#F9A542",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_116_7996",
    x1: 137.459,
    y1: 182.923,
    x2: 223.093,
    y2: 182.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00520833,
    stopColor: "#F9A542",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_116_7996",
    x1: 107.182,
    y1: 198.98,
    x2: 107.182,
    y2: 140.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BDA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BDA7B",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_116_7996",
    x1: 109.858,
    y1: 193.627,
    x2: 109.858,
    y2: 140.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BDA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BDA7B",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_116_7996",
    x1: 104.506,
    y1: 204.332,
    x2: 104.506,
    y2: 140.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BDA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BDA7B",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_116_7996",
    x1: 101.83,
    y1: 209.682,
    x2: 101.83,
    y2: 140.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BDA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BDA7B",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_116_7996",
    x1: 99.1541,
    y1: 215.037,
    x2: 99.1541,
    y2: 140.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BDA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BDA7B",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_116_7996",
    x1: 96.478,
    y1: 220.389,
    x2: 96.478,
    y2: 140.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BDA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BDA7B",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_116_7996",
    x1: 93.8019,
    y1: 225.742,
    x2: 93.8019,
    y2: 140.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BDA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BDA7B",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_116_7996",
    x1: 91.1258,
    y1: 231.096,
    x2: 91.1258,
    y2: 140.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BDA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BDA7B",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_116_7996",
    x1: 88.4497,
    y1: 236.443,
    x2: 88.4497,
    y2: 140.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BDA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BDA7B",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_116_7996",
    x1: 85.7737,
    y1: 241.797,
    x2: 85.7737,
    y2: 140.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BDA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BDA7B",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_7996"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.650391,
    width: 275.637,
    height: 276.699,
    rx: 9.58737,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreChart);
export default __webpack_public_path__ + "static/media/scoreChart.5eb8f686af5b021a1d779ecc9483c633.svg";
export { ForwardRef as ReactComponent };